import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { Row, Container } from "react-bootstrap";

import PageTitle from "../Common/PageTitle/PageTitle";
import PatientNameHeader from "./PatientNameHeader";
import PatientBasicDetail from "./PatientBasicDetail";
import "./PatientProfile.css";
import Notification from "./Notification";
import PatientFilter from "./PatientFilter";
import PatientDashboard from "./PatientDashboard";
import ApiService from "../../ApiService";

const PatientProfile = () => {
  const search = useLocation().search;
  const patientId = new URLSearchParams(search).get("patientId");
  const idType = new URLSearchParams(search).get("idType");

  const [patientDetail, setPatientDetail] = useState({});

  useEffect(() => {
    if (!patientId) {
      return;
    }
    ApiService.getPatientDetailsBySubId(patientId)
      .then(res => {
        console.log(res);
        if (res?.data) setPatientDetail(res.data);
      })
      .catch(err => {
        console.log(err);
      });
  }, [patientId]);

  return (
    <>
      <Container fluid className="patientProfile">
        <Row style={{ justifyContent: "center" }}>
          <PageTitle titleName={"Patient Profile"} />
        </Row>

        <PatientFilter />

        <Row className="patientInfo">
          <PatientNameHeader
            patientId={patientId}
            patientName={patientDetail?.preferredName || patientDetail?.name}
            patientPronune={patientDetail?.preferPronoun?.length > 0 ? patientDetail?.preferPronoun : patientDetail?.pronoun}            
          />
          <PatientBasicDetail patientDetail={patientDetail} />
          {/* <Notification /> */}
        </Row>

        <PatientDashboard patientId={patientId} patientDetail={patientDetail} />
      </Container>
    </>
  );
};

export default PatientProfile;
